
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.333 28h-14A2.34 2.34 0 015 25.667v-14a2.34 2.34 0 012.333-2.334h14a2.34 2.34 0 012.334 2.334v14A2.34 2.34 0 0121.333 28zm-14-16.333v14h14v-14h-14z"}}),_c('path',{attrs:{"d":"M21.333 11.667h-14V7c0-3.862 3.139-7 7-7 3.862 0 7 3.138 7 7v4.667zM9.667 9.333H19V7a4.665 4.665 0 00-4.667-4.667A4.665 4.665 0 009.667 7v2.333zM14.333 18.667a2.333 2.333 0 100-4.667 2.333 2.333 0 000 4.667z"}}),_c('path',{attrs:{"d":"M14.333 23.333a1.17 1.17 0 01-1.166-1.166v-5.834a1.17 1.17 0 011.166-1.166 1.17 1.17 0 011.167 1.166v5.834a1.17 1.17 0 01-1.167 1.166z"}})])
          )
        }
      }
    